export default __webpack_public_path__ + "static/media/twitter.fbe9618d.svg";